import React, { useState, useContext, useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useReactToPrint } from "react-to-print";

//pages & includes
import ManageSidebar from "../ManageSidebar";

//functions
import {
  _t,
  getCookie,
  checkPermission,
  pagination,
  paginationLoading,
  showingData,
  searchedShowingData,
  formatPrice,
  currencySymbolLeft,
  currencySymbolRight,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { MdDelete } from 'react-icons/md';

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "react-moment";
import { useCustomHooks } from "../../../../../functions/Hooks";

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { UserContext } from "../../../../../contexts/User";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";
import FgInvoicePrint from "./FgInvoicePrint";

const toastObj = {
  position: "bottom-center",
  autoClose: 10000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  className: "text-center toast-notification",
}

const FgSaleOrderList = () => {
    const { t } = useTranslation();
    const { roundOffStock } = useCustomHooks();
    //getting context values here
    let {
      //common
      loading,
      setLoading,

    } = useContext(SettingsContext);
    const {authUserInfo} = useContext(UserContext)
  
    let {
      //purchase order
      getPaginatedFgSaleOrder,
      setFgSaleOrderList,
      setFgSaleOrderForSearch,
      fgSaleOrderForSearch,
      fgSaleOrderList,

      //pagination
      dataPaginating,
      setDataPaginating,
    } = useContext(RestaurantContext);
    
    //search result
    let [searchedSale, setSearchedSale] = useState({
      list: null,
      searched: false,
    });
  
    //search purchase order here
    const handleSearch = (e) => {
      let searchInput = e.target.value.toLowerCase();
      if (searchInput.length === 0) {
        setSearchedSale({ ...searchedSale, searched: false });
      } else {
        let searchedList = fgSaleOrderForSearch.filter((item) => {
          //name
          let lowerCaseItemSupplierName = item.customer_name ? item.customer_name.toLowerCase() : "";
          //branch
          let lowerCaseBranch = item.branch_name ? item.branch_name.toLowerCase() : "";
          //email
          let lowerCaseItemInvoice =
            item.document_identity !== null && item.document_identity.toLowerCase();
  
          return (
            lowerCaseItemSupplierName.includes(searchInput) ||
            lowerCaseItemInvoice.includes(searchInput) || 
            lowerCaseBranch.includes(searchInput)
          );
        });
        setSearchedSale({
          ...searchedSale,
          list: searchedList,
          searched: true,
        });
      }
    };
  
    //delete confirmation modal of purchase order
    const handleDeleteConfirmation = (id) => {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="card card-body">
              <h1>{_t(t("Are you sure?"))}</h1>
              <p className="text-center">{_t(t("You want to delete this?"))}</p>
              <div className="d-flex justify-content-center">
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    handleDeleteSale(id);
                    onClose();
                  }}
                >
                  {_t(t("Yes, delete it!"))}
                </button>
                <button className="btn btn-success ml-2 px-3" onClick={onClose}>
                  {_t(t("No"))}
                </button>
              </div>
            </div>
          );
        },
      });
    };
  
    //delete purchase here
    const handleDeleteSale = (id) => {
      setLoading(true);
      const url = BASE_URL + `/settings/finished-good-sale-order/${id}`;
      return axios
        .delete(url, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setFgSaleOrderList(res.data[0]);
          setFgSaleOrderForSearch(res.data[1]);
          setSearchedSale({
            ...searchedSale,
            list: res.data[1],
          });
          setLoading(false);
          toast.success(`${_t(t("Order has been deleted"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        })
        .catch(() => {
          setLoading(false);
          toast.error(`${_t(t("Please try again"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        });
    };

  //print bills states and function
  const [newRow,setNewRow]=useState([]);
  let [newItem, setNewItem] = useState({
    invoice: '',
    branch: '',
    remarks: '',
    total_amount:''
  });
  const componentRef = useRef();
  const handleOnlyPrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const handleGetPrintData = async(id) => {
    const url = BASE_URL + "/settings/finished-good-sale-order/" + parseInt(id);
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if(res.data){
        const editFgInvoice = res.data;
        let docDate=new Date(editFgInvoice.document_date);
        let customer={
          id: editFgInvoice.customer_id,
          name: editFgInvoice.customer_name
        };
        // let branch=branchForSearch?.find((item)=>item.id === res.data.stock.branch_id)            
        setNewItem({
          ...newItem,
          date: docDate,
          invoice: editFgInvoice.document_identity,
          customer: customer,
          paymentType:editFgInvoice.payment_type,
          description:editFgInvoice?.desc ?? "",
          total_amount: editFgInvoice.total_amount,
        })
        let newArr=[];
        if(editFgInvoice.finished_good_sale_order_detail && editFgInvoice.finished_good_sale_order_detail.length>0){
          editFgInvoice.finished_good_sale_order_detail.map((item)=>{
            newArr.push({
              ingredient_name: item.item_name,
              qty: parseFloat(item.qty),
              rate: roundOffStock(item.price),
              amount: roundOffStock(item.amount),
              // total: roundOffStock(item.total),
            })
          })
          setNewRow([...newArr])
        }
        handleOnlyPrint();
      }
          
    } catch(error) {
      console.log("error==>",error)
      toast.success(`${_t(t("Please try again"))}`, toastObj);
    }
  }

  //post button function
  const handlePostApi = async (item) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/mark-is-post-fgso"
    let formData = new FormData();
    formData.append('id',item.id)
    formData.append('is_post', item.is_post ? 0 : 1)
    try {
      const res = await axios.post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
        if(res.data){
          setFgSaleOrderList(res.data[0]);
          setFgSaleOrderForSearch(res.data[1]);
          setSearchedSale({
            ...searchedSale,
            list: res.data[1],
          });
          toast.success(`${_t(t(item?.is_post ? "Sale Order has been unpost" : "Sale Order has been post"))}`,{
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        }
        setDataPaginating(false);
    } catch(err) {
      setDataPaginating(false);
      if(err.response?.data?.status === "error"){
        toast.error(`${_t(t(err.response.data.message))}`,{
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        return
      }
      toast.error(`${_t(t("Please try again"))}`,{
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  }

  //unpost confirmation modal
  const handleUnPostConfirmation = (item) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body px-5">
            <h3>{_t(t("Are you sure?"))}</h3>
            <p className="text-center">{_t(t("You want to un post this?"))}</p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary"
                onClick={() => {
                  handlePostApi(item);
                  onClose();
                }}
              >
                {_t(t("Yes, unpost it!"))}
              </button>
              <button className="btn btn-success ml-2 px-3" onClick={onClose}>
                {_t(t("No"))}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  return (
    <>
    <Helmet>
      <title>{_t(t("FG Sale Order"))}</title>
    </Helmet>

    {/* main body */}
    <main id="main" data-simplebar>
      <div className="container-fluid">
        <div className="row t-mt-10 gx-2">
          {/* left Sidebar */}
          <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
            <ManageSidebar />
          </div>
          {/* left Sidebar ends */}

          {/* Rightbar contents */}
          <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
            <div className="t-bg-white">
              <div className="fk-scroll--pos-table-menu" data-simplebar>
                <div className="t-pl-15 t-pr-15">
                  {/* Loading effect */}
                  {/* {newSupplier.uploading === true || loading === true ? (
                    tableLoading()
                  ) : ( */}
                    <div key="fragment3">
                      {/* next page data spin loading */}
                      <CustomSpinLoader loading={loading || dataPaginating}/>
                      {/* spin loading ends */}

                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {!searchedSale.searched
                                  ? _t(t("FG Sale Order List"))
                                  : _t(t("Search Result"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                        <div className="col-md-6 col-lg-7">
                          <div className="row gx-3 align-items-center">
                            {/* Search customer */}
                            <div className="col-md-9 t-mb-15 mb-md-0">
                              <div className="input-group">
                                <div className="form-file">
                                  <input
                                    type="text"
                                    className="form-control border-0 form-control--light-1 rounded-left"
                                    placeholder={_t(t("Search")) + ".."}
                                    onChange={handleSearch}
                                  />
                                </div>
                                <button
                                  className="btn btn-primary rounded-right"
                                  type="button"
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                              </div>
                            </div>

                            {/* Add customer modal trigger button */}
                            <div className="col-md-3 text-md-right">
                              <NavLink
                                to="/dashboard/manage/stock/fg-sale-order-add"
                                className="btn btn-primary xsm-text text-uppercase btn-lg btn-block rounded"
                              >
                                {_t(t("add new"))}
                              </NavLink>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Table */}
                      <div className="">
                        <table className="table table-bordered table-hover min-table-height">
                          <thead className="align-middle">
                            <tr>
                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("S/L"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Fg Order #"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Date"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Branch"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Customer"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Total"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Action"))}
                              </th>
                            </tr>
                          </thead>
                          <tbody className="align-middle">
                            {/* loop here, logic === !search && haveData && haveDataLegnth > 0*/}
                            {!searchedSale.searched
                              ? [
                                fgSaleOrderList && [
                                  fgSaleOrderList.data?.length === 0 ? (
                                    <tr className="align-middle">
                                      <td
                                        scope="row"
                                        colSpan="7"
                                        className="xsm-text align-middle text-center"
                                      >
                                        {_t(t("No data available"))}
                                      </td>
                                    </tr>
                                  ) : (
                                    Array.isArray(fgSaleOrderList?.data) && fgSaleOrderList.data.map(
                                      (item, index) => {
                                        return (
                                          <tr
                                            className="align-middle"
                                            key={index}
                                          >
                                            <th
                                              scope="row"
                                              className="xsm-text text-capitalize align-middle text-center"
                                            >
                                              {index +
                                                1 +
                                                (fgSaleOrderList.current_page -
                                                  1) *
                                                  fgSaleOrderList.per_page}
                                            </th>

                                            <td className="xsm-text align-middle text-center">
                                              {item.document_identity}
                                            </td>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              <Moment format="LL">
                                                {item.document_date}
                                              </Moment>
                                            </td>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                            {item.branch.name}
                                            </td>
                                          
                                            <td className="xsm-text text-capitalize align-middle text-center">
                                            {item.customer_name}
                                            </td>
                                            
                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              {currencySymbolLeft()}
                                              {formatPrice(Number(item.total_amount))}
                                              {currencySymbolRight()}
                                            </td>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              <div className="d-flex justify-content-center">                                                    
                                              {
                                                item.is_post !== 1 ? (
                                                  <>
                                                    <NavLink
                                                    className="btn btn-primary ml-2 rounded-sm"
                                                    to={`/dashboard/manage/stock/fg-sale-order-edit/${item.id}`}
                                                    style={{height:"1.7rem",width:"1.7rem"}}                                                                                                                                              
                                                    >
                                                      <div className="d-flex align-items-center justify-content-center">
                                                        <i className="fa fa-pencil edit-icon" aria-hidden="true"></i>
                                                      </div>
                                                    </NavLink>
                                                    <button
                                                    className="btn btn-danger ml-2 rounded-sm del-btn"
                                                    onClick={()=>handleDeleteConfirmation(item.id)}                                                    
                                                    >                                                    
                                                      <MdDelete className="del-icon" />                                                    
                                                    </button>
                                                  </>
                                                ): ""
                                              }
                                                <button
                                                className="btn btn-secondary ml-2 rounded-sm del-btn"
                                                onClick={()=>handleGetPrintData(item.id)}
                                                >
                                                  <i className="fa fa-print edit-icon"></i>
                                                </button>
                                                {/* checkPermission(authUserInfo.permissions, "PI Post") && */}
                                                {(checkPermission(authUserInfo.permissions, "PI Post") && item.is_post !== 1 ? <button
                                                    className="btn btn-dark ml-2 rounded-sm del-btn"
                                                    title="Post PI" 
                                                    style={{padding:"1px 0px 0px 1px"}} 
                                                    disabled={loading}                                              
                                                    onClick={()=>handlePostApi(item)}
                                                  >
                                                    <i className="fa fa-check-square-o" aria-hidden="true"></i>
                                                  </button> : null)
                                                }
                                              </div> 
                                            </td>
                                          </tr>
                                        );
                                      }
                                    )
                                  ),
                                ],
                              ]
                              : [
                                /* searched data, logic === haveData*/
                                searchedSale && [
                                  searchedSale.list.length === 0 ? (
                                    <tr className="align-middle">
                                      <td
                                        scope="row"
                                        colSpan="7"
                                        className="xsm-text align-middle text-center"
                                      >
                                        {_t(t("No data available"))}
                                      </td>
                                    </tr>
                                  ) : (
                                    searchedSale.list.map(
                                      (item, index) => {
                                        return (
                                          <tr
                                            className="align-middle"
                                            key={index}
                                          >
                                            <th
                                              scope="row"
                                              className="xsm-text text-capitalize align-middle text-center"
                                            >
                                              {index +
                                                1 +
                                                (fgSaleOrderList.current_page -
                                                  1) *
                                                  fgSaleOrderList.per_page}
                                            </th>

                                            <td className="xsm-text align-middle text-center">
                                            {item.document_identity}
                                            </td>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              <Moment format="LL">
                                                {item.document_date}
                                              </Moment>
                                            </td>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                            {item.branch.name}
                                            </td>
                                          
                                            <td className="xsm-text text-capitalize align-middle text-center">
                                            {item.customer_name}
                                            </td>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              {currencySymbolLeft()}
                                              {formatPrice(item.total_amount)}
                                              {currencySymbolRight()}
                                            </td>

                                            <td className="xsm-text text-capitalize align-middle text-center">                                              
                                              <div className="d-flex justify-content-center">                                                    
                                                {
                                                  item.is_post !== 1 ? (
                                                    <>
                                                      <NavLink
                                                        className="btn btn-primary ml-2 rounded-sm"
                                                        to={`/dashboard/manage/stock/fg-sale-order-edit/${item.id}`}
                                                        style={{height:"1.7rem",width:"1.7rem"}}                                                                                                                                              
                                                      >
                                                        <div className="d-flex align-items-center justify-content-center">
                                                          <i className="fa fa-pencil edit-icon" aria-hidden="true"></i>
                                                        </div>
                                                      </NavLink>
                                                      <button
                                                      className="btn btn-danger ml-2 rounded-sm del-btn"
                                                      onClick={()=>handleDeleteConfirmation(item.id)}                                                    
                                                      >                                                    
                                                        <MdDelete className="del-icon" />                                                    
                                                      </button>
                                                    </>
                                                  ): ""
                                                }
                                                <button
                                                className="btn btn-danger ml-2 rounded-sm del-btn"
                                                onClick={()=>handleDeleteConfirmation(item.id)}                                                    
                                                >                                                    
                                                  <MdDelete className="del-icon" />                                                    
                                                </button>
                                                <button
                                                className="btn btn-secondary ml-2 rounded-sm del-btn"
                                                >
                                                  <i className="fa fa-print edit-icon"></i>
                                                </button>
                                              </div> 
                                              <button
                                              className="btn btn-secondary ml-2 rounded-sm del-btn"
                                              onClick={()=>handleGetPrintData(item.id)}
                                              >
                                                <i className="fa fa-print edit-icon"></i>
                                              </button>
                                              {/* checkPermission(authUserInfo.permissions, "PI Post") && */}
                                              {(checkPermission(authUserInfo.permissions, "PI Post") && item.is_post !== 1 ? <button
                                                  className="btn btn-dark ml-2 rounded-sm del-btn"
                                                  title="Post PI" 
                                                  style={{padding:"1px 0px 0px 1px"}} 
                                                  disabled={loading}                                              
                                                  onClick={()=>handlePostApi(item)}
                                                >
                                                  <i className="fa fa-check-square-o" aria-hidden="true"></i>
                                                </button> : null)
                                              }
                                            </td>
                                          </tr>
                                        );
                                      }
                                    )
                                  ),
                                ],
                              ]}
                          </tbody>
                        </table>
                      </div>
                    </div>                  
                </div>
              </div>
            </div>

            {/* pagination loading effect */}
            {loading === true
              ? paginationLoading()
              : [
                // logic === !searched
                !searchedSale.searched ? (
                  <div key="fragment4">
                    <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                      <div className="row align-items-center t-pl-15 t-pr-15">
                        <div className="col-md-7 t-mb-15 mb-md-0">
                          {/* pagination function */}
                          {pagination(
                            fgSaleOrderList,
                            getPaginatedFgSaleOrder
                          )}
                        </div>
                        <div className="col-md-5">
                          <ul className="t-list d-flex justify-content-md-end align-items-center">
                            <li className="t-list__item">
                              <span className="d-inline-block sm-text">
                                {showingData(fgSaleOrderList)}
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  // if searched
                  <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                    <div className="row align-items-center t-pl-15 t-pr-15">
                      <div className="col-md-7 t-mb-15 mb-md-0">
                        <ul className="t-list d-flex">
                          <li className="t-list__item no-pagination-style">
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={() =>
                                setSearchedSale({
                                  ...searchedSale,
                                  searched: false,
                                })
                              }
                            >
                              {_t(t("Clear Search"))}
                            </button>
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-5">
                        <ul className="t-list d-flex justify-content-md-end align-items-center">
                          <li className="t-list__item">
                            <span className="d-inline-block sm-text">
                              {searchedShowingData(
                                searchedSale,
                                fgSaleOrderForSearch
                              )}
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                ),
              ]}
          </div>
          {/* Rightbar contents end*/}
        </div>
      </div>
    </main>
    {/* main body ends */}
    <FgInvoicePrint
      name = "Fg Sale Order"
      newItem={newItem}
      newRow={newRow}
      invoiceNo = {"Order No"}
      inoviceDate = {"Order Date"}
      FgPrint={componentRef}
    /> 
  </>
  )
}

export default FgSaleOrderList
